export const hotkeys = {
    sidebar: 'esc',	            //Oldalsáv
    startPause: 'space',	    //Idő megállít / Elindít
    directionChange: 'tab',	    //Támadás irányának fordítása
    timeout: 't',               //Időkérés (ha lehet)
    emptyGoal: 'e',     	    //A támadó(warning) csapatnál lehozza a kapust és üres kaput állít be (empty goal)
    fillGoal: 'shift+e',        //Az utoljára beállított üres kapus szituáció visszaállítása, arra a kapusra, aki akkor leült a padra.
    penalty2: '2',              //A 2 perces kiállítása "gombjának" benyomása (tehát nem automatikus 2 perc, csak gombnyomás), ha lehetséges
    penalty4: '4',              //A 4 perces kiállítása "gombjának" benyomása (tehát nem automatikus 2 perc, csak gombnyomás), ha lehetséges
    yellowCard: 's',            //Sárga lap "gomb" benyomása, ha lehetséges
    redCard: 'p',               //Piros lap "gomb" benyomása, ha lehetséges
    blueCard: 'b',              //Kék lap "gomb" benyomása, ha lehetséges
    kiallitasCard: 'alt+k',     //Kiállítás
    lostBall: 'l',              //eladott labda
    techFailure: 'h',           //technikai hiba
    shotMiss: 'r',              //Rontott lövés
    barShot: 'k',               //Kapufa
    defendedShot: 'v',          //Védett lövés
    goal: 'g',                  //Gól
    goal2p: 'ctrl+g',           //2pontos Gól
    shotMiss7m: 'shift+r',      //7m Rontott lövés
    barShot7m: 'shift+k',       //7m Kapufa
    defendedShot7m: 'shift+v',  //7m Védett lövés
    shotMiss6m: 'shift+r',      //6m Rontott lövés
    barShot6m: 'shift+k',       //6m Kapufa
    defendedShot6m: 'shift+v',  //6m Védett lövés
    goal7m: 'shift+g',          //7m Gól
    goal6m: 'shift+g',          //6m Gól
    normalShot: 'ctrl+n',       //Normál lövés
    porgoShot: 'ctrl+p',        //Pörgő lövés
    specialistaShot: 'ctrl+s',  //Specialista lövés
    kinaiShot: 'ctrl+k',        //Kínai lövés
    direktShot: 'ctrl+d',       //Direkt lövés
};
